import React, { useState, useMemo } from "react";
import debounce from "lodash/debounce";
import { useTranslation } from "react-i18next";

const YesNoQuestion = ({
  options: parentOptions,
  setOptions,
  isRequired,
  setIsRequired,
  isAdditionalComments,
  setIsAdditionalComments,
  commentPlaceholder,
  setCommentPlaceholder,
  selectedOption,
  setSelectedOption,
  isCompulsory,
  setIsCompulsory,
}) => {
  const { t } = useTranslation();

  const [localOptions] = useState([
    { id: 1, text: "Yes" },
    { id: 2, text: "No" },
  ]);

  const options = parentOptions || localOptions;

  const debounceHandleSetCommentPlaceholder = useMemo(
    () => debounce((value) => setCommentPlaceholder(value), 50),
    [setCommentPlaceholder]
  );

  const handleCommentPlaceholder = (e) => {
    const value = e.target.value;
    debounceHandleSetCommentPlaceholder(value);
  };

  return (
    <>
      <div className="space-y-2 mb-4">
        {options.map((option) => (
          <div
            key={option.id}
            className="bg-white rounded-full p-4 flex items-center"
          >
            <input
              type="radio"
              name="yesno-option"
              className="w-5 h-5 text-indigo-600 mr-3"
              onChange={() => setSelectedOption(option.id)}
              checked={selectedOption === option.id}
            />
            <span className="flex-1">{option.text}</span>
          </div>
        ))}
      </div>

      <div className="space-y-4 mb-4">
        <div className="flex items-center gap-2">
          <label className="inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={isRequired}
              onChange={() => setIsRequired(!isRequired)}
            />
            <div className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-indigo-600"></div>
          </label>
          <span className="text-gray-500">{t("base.required")}</span>
        </div>

        <div className="flex items-center gap-2">
          <label className="inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={isAdditionalComments}
              onChange={() => setIsAdditionalComments(!isAdditionalComments)}
            />
            <div className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-indigo-600"></div>
          </label>
          <span className="text-gray-500">
            {t("base.addAdditionalComments")}
          </span>
        </div>

        {isAdditionalComments && (
          <>
            <div className="bg-white rounded-lg p-4">
              <input
                type="text"
                value={commentPlaceholder}
                onChange={handleCommentPlaceholder}
                className="w-full border-0 focus:ring-0 text-sm text-gray-400 focus:outline-none"
                placeholder={t("base.pleaseElaborate")}
              />
            </div>
            <div className="flex justify-between">
              <div></div>
              <div className="flex items-center gap-2">
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={isCompulsory}
                    onChange={() => setIsCompulsory(!isCompulsory)}
                  />
                  <div className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-indigo-600"></div>
                </label>
                <span className="text-gray-500">{t("base.compulsory")}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default YesNoQuestion;
